<template>
  <div class="restriction-info">
    <div v-if="showHelpInfo" class="restriction-info__help">
      <a href="#" class="restriction-info__close" @click.prevent="$emit('setShowHelpInfo',false)">
        &times;
      </a>
      <p class="restriction-info__text">
        due to carrier restrictions and to ensure that we better deliver this message to your members, the following
        term(s) must be removed or replaced. please reach out to your client success manager for questions or concerns
        or reach out to support <a :href="mailtoLink" target="_blank">{{supportEmail}}</a>
      </p>
    </div>
    <a href="#" class="restriction-info__open" @click.prevent="$emit('setShowHelpInfo', !showHelpInfo)">help</a>
  </div>
</template>

<script>
  import Modal from '../shared/Modal'

  export default {
    props: {
      restrictedTerm: {
        default: '',
        type: String
      },

      showHelpInfo: Boolean,
    },

    name: 'SmsCarrierRestrictionInfo',

    components: {
      Modal,
    },

    data() {
      return {
        supportEmail: 'support@springbig.com',
      }
    },

    computed: {
      mailtoLink: function () {
        const emailSubject = 'carrier restrictions',
          emailBody = `the term ${this.restrictedTerm} was not allowed`
        return `mailto:${this.supportEmail}?subject=${encodeURI(emailSubject)}&body=${encodeURI(emailBody)}`
      },
    },

    beforeDestroy() {
      this.$emit('setShowHelpInfo', false)
    },
  }
</script>